// extracted by mini-css-extract-plugin
module.exports = {"root":"LiveAuctionsAside_root__1Xmju","tabs":"LiveAuctionsAside_tabs__2tBGL"};